import { render } from "./SubmitPropsCmp.vue?vue&type=template&id=7979a915"
import script from "./SubmitPropsCmp.vue?vue&type=script&lang=js"
export * from "./SubmitPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__